__turbopack_context__.v({
  "container": "EnterFlowFooter-module__DC4nEa__container",
  "variant2": "EnterFlowFooter-module__DC4nEa__variant2",
});
